<flexyoo-common-list
  [columns]="columns"
  [dataSource]="dataSource()"
  (pagerChanged)="onPagerChanged($event)"
>
  <app-tenant-groups-filter
    ngProjectAs="header"
    (createTenantGroup)="createTenantGroup()"
  ></app-tenant-groups-filter>
  <ng-template flexyooCommonListColumn="actions" let-row>
    <app-table-item-actions
      [isActive]="row.IsActive"
      [showActivate]="false"
      [showDuplicate]="false"
      (action)="onItemAction.emit({ action: $event, item: row })"
    >
      <app-impersonate-button
        [isFlat]="true"
        [isTableActionView]="true"
        (impersonate)="onItemAction.emit({ action: 'impersonate', item: row })"
      ></app-impersonate-button>
    </app-table-item-actions>
  </ng-template>
  <ng-template flexyooCommonListColumn="contextMenuActions" let-row>
    <button
      class="context-action-button"
      matButton="filled"
      (click)="onItemAction.emit({ action: 'edit', item: row })"
    >
      {{ 'admin.users.list.actions.modify' | translate }}
    </button>
    <button
      class="context-action-button fo-color-error"
      matButton="filled"
      (click)="onItemAction.emit({ action: 'delete', item: row })"
    >
      {{ 'admin.users.list.actions.delete' | translate }}
    </button>
    <app-impersonate-button
      [isFlat]="true"
      [isTableActionView]="true"
      (impersonate)="onItemAction.emit({ action: 'impersonate', item: row })"
    ></app-impersonate-button>
  </ng-template>
</flexyoo-common-list>
